import { keyBy } from 'lodash';

import classes from './SettingsSelectSolution.module.scss';

const SettingsSelectSolution = ({
  solutionLists,
  value,
  onChange,
  translate,
  solutions,
  solutionLocale,
}) => {
  const solutionsMap = keyBy(solutions, '_id');

  const uiLocale =
    solutionLocale?.code ||
    translate?.getLocale?.() ||
    translate?.currentLocale ||
    translate?.locale ||
    'unknown';

  console.log('SettingsSelectSolution init:', {
    uiLocale,
    solutionListsCount: Array.isArray(solutionLists) ? solutionLists.length : 'n/a',
  });

  return (
    <div className={classes.listsWrapper}>
      {solutionLists.map((list) => {
        const labelKey = list.titleStringNumber || 940;
        const labelText = translate(labelKey, 'Modules');

        console.log('SettingsSelectSolution label debug:', {
          listId: list.id,
          rawTitleStringNumber: list.titleStringNumber,
          usedLabelKey: labelKey,
          uiLocale,
          labelText,
        });

        return (
          <div className={classes.radioListWrapper} key={list.id}>
            <p className={classes.radioListLabel}>
              {labelText}
            </p>

            <div className={classes.radioList}>
              {list.items.map((solutionId) => {
                const solution = solutionsMap[solutionId];
                if (!solution) return null;

                return (
                  <label key={solutionId}>
                    <input
                      checked={solutionId === value}
                      value={solutionId}
                      onChange={() => onChange(solutionId)}
                      type="radio"
                    />
                    <span>{solution.displayName}</span>
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SettingsSelectSolution;
